import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var _dec, _class;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
import { Component, createRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyle, jsx } from '@instructure/emotion';
import * as CaptureActions from '../../../actions';
import generateStyle from './styles';

/**
---
private: true
---
**/
let ScreenStream = (_dec = withStyle(generateStyle, null), _dec(_class = class ScreenStream extends Component {
  constructor(props) {
    super(props);
    this.video = /*#__PURE__*/createRef();
  }
  componentDidMount() {
    const _this$props = this.props,
      streamMerger = _this$props.streamMerger,
      makeStyles = _this$props.makeStyles,
      initWebcam = _this$props.initWebcam,
      startMergedStream = _this$props.startMergedStream;
    makeStyles();
    initWebcam();
    startMergedStream();
    if (this.video.current) {
      this.video.current.srcObject = streamMerger.getStream();
    }
  }
  componentWillUnmount() {
    const stopMergedStream = this.props.stopMergedStream;
    stopMergedStream();
    if (this.video.current) {
      this.video.current.pause();
      this.video.current.removeAttribute('src');
      this.video.current.srcObject = void 0;
      this.video.current.load();
    }
  }
  componentDidUpdate() {
    const _this$props2 = this.props,
      makeStyles = _this$props2.makeStyles,
      streamMerger = _this$props2.streamMerger;
    makeStyles();
    if (this.video.current) {
      this.video.current.srcObject = streamMerger.getStream();
    }
  }
  render() {
    const styles = this.props.styles;
    return jsx("video", {
      ref: this.video,
      muted: true,
      css: styles.canvas,
      autoPlay: true
    });
  }
}) || _class);
const mapStateToProps = state => ({
  streamMerger: state.streamMerger
});
const mapDispatchToProps = dispatch => _objectSpread({}, bindActionCreators(CaptureActions, dispatch));
export default connect(mapStateToProps, mapDispatchToProps)(ScreenStream);